/*
  RheasRaw: "Show more" on collection pages instead of numbered pages (Nov 2026).

  Clarity showed phone shoppers paging back and forth (2 > 3 > 4 > back) on the raw food
  collections. This swaps Empire's pagination for one button that adds the next page of
  products under the ones already showing. When a shopper opens a product and comes back,
  the extra pages are put back and the page scrolls to where they were.

  Without JavaScript the normal numbered pages still work. Loaded from sections/rr-collection-extras.liquid.
*/
(function () {
  if (window.__rrLoadMore) return;
  window.__rrLoadMore = true;

  function key() { return 'rr_lm:' + location.pathname + location.search; }
  var busy = false;

  function grid() { return document.querySelector('[data-productgrid-items]'); }
  function nav() { return document.querySelector('.pagination--container'); }
  function nextUrl(scope) {
    var a = (scope || document).querySelector('.pagination--next a[href]');
    return a ? a.getAttribute('href') : '';
  }
  function readState() { try { return JSON.parse(sessionStorage.getItem(key()) || 'null'); } catch (e) { return null; } }
  function writeState(s) { try { sessionStorage.setItem(key(), JSON.stringify(s)); } catch (e) { /* full or blocked */ } }

  function count() { return grid() ? grid().querySelectorAll('[data-product-item]').length : 0; }

  function button() {
    var wrap = document.querySelector('[data-rr-load-more]');
    if (wrap) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'rr-load-more';
    wrap.setAttribute('data-rr-load-more', '');
    wrap.innerHTML = '<p class="rr-load-more__count" data-rr-lm-count></p><button type="button" class="rr-load-more__btn" data-rr-lm-btn>Show more</button><p class="rr-load-more__status" role="status" aria-live="polite" data-rr-lm-status></p>';
    var n = nav();
    n.parentNode.insertBefore(wrap, n);
    wrap.querySelector('[data-rr-lm-btn]').addEventListener('click', loadNext);
    return wrap;
  }

  function refresh() {
    var n = nav();
    var g = grid();
    if (!n || !g) return;
    var url = nextUrl(n);
    var totalEl = document.querySelector('[data-rr-collection-total]');
    var total = totalEl ? parseInt(totalEl.getAttribute('data-rr-collection-total'), 10) : 0;
    var hasPrev = !!n.querySelector('.pagination--previous a');
    // Only take over when we're on the first page (so a shared ?page=3 link still works).
    if (hasPrev) return;
    n.hidden = true;
    var b = button();
    var shown = count();
    b.querySelector('[data-rr-lm-count]').textContent = total ? 'Showing ' + shown + ' of ' + total : '';
    var btn = b.querySelector('[data-rr-lm-btn]');
    btn.hidden = !url;
  }

  function append(html) {
    var g = grid();
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var nodes = Array.prototype.slice.call(tmp.children);
    nodes.forEach(function (n) { n.setAttribute('data-rr-lm-added', ''); g.appendChild(n); });
    try { document.dispatchEvent(new CustomEvent('rr:products-added', { detail: { nodes: nodes } })); } catch (e) {}
    return nodes;
  }

  function loadNext() {
    var b = button();
    var btn = b.querySelector('[data-rr-lm-btn]');
    var status = b.querySelector('[data-rr-lm-status]');
    var url = nextUrl(nav());
    if (!url || busy) return;
    busy = true;
    btn.disabled = true;
    btn.textContent = 'Loading…';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var g2 = doc.querySelector('[data-productgrid-items]');
        if (!g2) throw new Error('no grid');
        var html = g2.innerHTML;
        var first = append(html)[0];
        // Swap in the next page's pagination so the button knows what comes next.
        var n2 = doc.querySelector('.pagination--container');
        var n = nav();
        var next = n2 ? nextUrl(n2) : '';
        var s = readState() || { html: '' };
        s.html += html;
        s.next = next;
        writeState(s);
        if (n) {
          var nextLi = n.querySelector('.pagination--next a');
          if (nextLi && next) nextLi.setAttribute('href', next);
          else if (nextLi) nextLi.parentNode.removeChild(nextLi);
        }
        status.textContent = '';
        refresh();
        if (first) {
          var link = first.querySelector('a[href]');
          if (link) try { link.focus({ preventScroll: true }); } catch (e) {}
        }
      })
      .catch(function () {
        status.innerHTML = 'Couldn’t load more. <a href="' + url + '">Go to the next page</a>';
      })
      .then(function () {
        busy = false;
        btn.disabled = false;
        btn.textContent = 'Show more';
      });
  }

  // Remember where the shopper was before they open a product.
  function saveScroll() {
    var s = readState();
    if (!s) return;
    s.y = window.scrollY;
    writeState(s);
  }
  window.addEventListener('pagehide', saveScroll);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-productgrid-items] a[href]');
    if (a) saveScroll();
  }, true);

  function restore() {
    var s = readState();
    if (!s || !s.html) return;
    var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var isBack = navEntry ? navEntry.type === 'back_forward' : false;
    if (!isBack) { try { sessionStorage.removeItem(key()); } catch (e) {} return; }
    append(s.html);
    var n = nav();
    var nextLi = n && n.querySelector('.pagination--next a');
    if (nextLi) {
      if (s.next) nextLi.setAttribute('href', s.next);
      else nextLi.parentNode.removeChild(nextLi);
    }
    if (typeof s.y === 'number') {
      try { history.scrollRestoration = 'manual'; } catch (e) {}
      requestAnimationFrame(function () { window.scrollTo(0, s.y); });
      setTimeout(function () { window.scrollTo(0, s.y); }, 300);
    }
  }

  // Empire wires up the add buttons only on cards that were there when the page loaded, so
  // cards added by "Show more" get a simple add of their own: single-size products go straight
  // into the basket (size buttons from rr-size-pills.js land here too), products with options
  // open the product page.
  function updateCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
        el.setAttribute('data-header-cart-count', c.item_count > 0 ? c.item_count : '');
        el.textContent = c.item_count > 0 ? c.item_count : '';
        el.classList.toggle('visible', c.item_count > 0);
      });
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-rr-lm-added] [data-quick-buy], [data-rr-lm-added] [data-quickshop-slim]');
    if (!t) return;
    e.preventDefault();
    var card = t.closest('[data-product-item]');
    if (t.hasAttribute('data-quickshop-slim')) {
      var link = card && card.querySelector('a[data-product-page-link], a[href*="/products/"]');
      if (link) location.href = link.href;
      return;
    }
    var id = Number(t.getAttribute('data-variant-id'));
    if (!id || t.__rrBusy) return;
    t.__rrBusy = true;
    var label = t.textContent;
    var pill = card && card.querySelector('.is-adding');
    var shown = pill || t;
    var shownLabel = shown.innerHTML;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); shown.textContent = 'Added \u2713'; updateCount(); })
      .catch(function () { shown.textContent = 'Sorry, try again'; })
      .then(function () {
        setTimeout(function () { shown.innerHTML = shownLabel; t.__rrBusy = false; }, 1800);
      });
  });

  function start() {
    if (!grid() || !nav()) return;
    if (nav().querySelector('.pagination--previous a')) return;
    restore();
    refresh();
    // Empire's filters and sorting swap the grid and pagination in place: take over the new one.
    try {
      new MutationObserver(function () {
        var n = nav();
        if (n && !n.hidden && !busy) refresh();
      }).observe(document.querySelector('#site-main') || document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}());
